module.exports = __webpack_public_path__ + "img/sa-beanie@3x.1e059d01.png";